import React, {useEffect, useState} from 'react';
import {Button, Form, Loader} from 'react-bulma-components';
import {useSearchParams} from 'react-router-dom';
import transactionService from '../services/transaction/transaction.service';

const VerifyTransactionPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [transactionId, setTransactionId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState('');

  useEffect(() => {
    (async () => {
      const id = searchParams.get('acsTransID');
      if (id == null) {
        return;
      }

      setTransactionId(id);

      setIsLoading(true);

      try {
        const {status} = await transactionService.getTransactionStatus(id);
        setStatus(status);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [searchParams]);

  const checkStatus = (): void => {
    setSearchParams({acsTransID: transactionId});
  };

  return (
    <>
      <Form.Field>
        <Form.Label>Transaction id</Form.Label>
        <Form.Control>
          <Form.Input
            color="success"
            value={transactionId}
            onChange={({target}) => setTransactionId(target.value)}
          />
        </Form.Control>
      </Form.Field>

      <Form.Field>
        <Form.Control
          display="flex"
          alignItems="center"
        >
          <Button
            onClick={checkStatus}
          >
            Check status
          </Button>

          &nbsp;

          Transaction status: {isLoading ?
            <Loader display="inline-block"/> :
            <span style={{fontWeight: 'bold', textTransform: 'capitalize'}}>&nbsp;{status}</span>
          }
        </Form.Control>
      </Form.Field>
    </>
  );
};

export default VerifyTransactionPage;
